import { createSelector } from '@reduxjs/toolkit'

import { coreApi } from '../../../api/core'

const openGames = coreApi.endpoints.getSetting.select('open_games')
const featuredGames = coreApi.endpoints.getSetting.select('featured_games')

export const selectOpenGames = createSelector(openGames, (result) => result.data)
export const selectFeaturedGames = createSelector(featuredGames, (result) => result.data)
